export default {
    equipamentos: [],
    equipamento: {},
    implementos: [],
    implemento: [],
    acessorios: [],
    acessorio: [],
	proprietarios: [],
	proprietario: [],
    equipamentosPlano: [],
    ultimaAtualizacaoEquipamento: Date
}